// extracted by mini-css-extract-plugin
export default {"navigation":"Tabs_navigation__kCPDd","navigationInner":"Tabs_navigationInner__ll04c","button":"Tabs_button__EVG8V","active":"Tabs_active__8JY7S"};